import React from 'react';
import styled, { useTheme } from 'styled-components';
import WidthContainer from '../../../WidthContainer';
import { BodyLarge, Heading1Text } from '../../../Texts';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';

const BackgroundColor = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.primary.primary};
`;

const Image1 = styled.img`
  position: absolute;
  top: 0px;
  left: 10%;
  @media ${PHONE_MEDIA_QUERY} {
    opacity: 0.2;
  }
`;

const Image2 = styled.img`
  position: absolute;
  bottom: 5%;
  left: 0px;
  @media ${PHONE_MEDIA_QUERY} {
    opacity: 0.2;
  }
`;

const Image3 = styled.img`
  position: absolute;
  top: 0px;
  right: 15%;
  @media ${PHONE_MEDIA_QUERY} {
    opacity: 0;
  }
`;

const Image4 = styled.img`
  position: absolute;
  bottom: 5%;
  right: 0px;
  @media ${PHONE_MEDIA_QUERY} {
    opacity: 0.2;
  }
`;

const Container = styled.div`
  min-height: 700px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 2;
  position: relative;
  @media ${PHONE_MEDIA_QUERY} {
    text-align: center;
  }
`;

const ComponentContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 10px;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
  }
`;

const Component = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.border.primary};
  border-radius: 16px;
  width: 350px;
  padding: 20px 10px;
  @media ${PHONE_MEDIA_QUERY} {
    width: 100%;
  }
`;

const WhoShouldApply = () => {
  const theme = useTheme();
  return (
    <BackgroundColor>
      <Image1 src='/easyToBuy1.webp' />
      <Image2 src='/easyToBuy2.webp' />
      <Image3 src='/easyToBuy3.webp' />
      <Image4 src='/easyToBuy4.webp' />
      <WidthContainer>
        <Container>
          <Heading1Text style={{ color: 'white' }}>
            Who Should{' '}
            <span style={{ color: theme.special.purple }}>Apply?</span>
          </Heading1Text>
          <ComponentContainer>
            <Component>
              <BodyLarge>Web3 growth agencies & launchpads</BodyLarge>
            </Component>
            <Component>
              <BodyLarge>Influencers / KOLs in crypto communities</BodyLarge>
            </Component>
          </ComponentContainer>
          <ComponentContainer>
            <Component>
              <BodyLarge>DAO connectors & token scouts</BodyLarge>
            </Component>
            <Component>
              <BodyLarge>Freelancers helping projects go live</BodyLarge>
            </Component>
          </ComponentContainer>
        </Container>
      </WidthContainer>
    </BackgroundColor>
  );
};

export default WhoShouldApply;
